/*
 * @Description:
 * @Author: fal
 * @Date: 2025-08-11 15:31:32
 * @FilePath: \xhlz_pc\src\main.js
 * @LastEditTime: 2025-09-08 13:58:01
 */
import Vue from 'vue';
import ElementUI from 'element-ui';
import VueMatomo from 'vue-matomo';
import 'element-ui/lib/theme-chalk/index.css';
import './util/scale';
import App from './App.vue';
import router from './router';
import store from './store';
import { apiURL, newApiURL, matomoURL, siteId } from './config/index.js';
import vueUeditorWrap from 'vue-ueditor-wrap';

import './css/element.less';

import './css/font/iconfont.css';
import './project/css/font/iconfont.css';

Vue.use(VueMatomo, {
  host: matomoURL,
  siteId
});
Vue.component('vue-ueditor-wrap', vueUeditorWrap);
Vue.use(ElementUI, { zIndex: 100 });
import less from 'less';
Vue.use(less);
import axios from 'axios';
Vue.prototype.$axios = axios;
import utils from '@/util/utils.js';
Vue.prototype.$bus = new Vue();
require('../mock/index');

Vue.prototype.$url = apiURL;
Vue.prototype.$api = newApiURL;
Vue.prototype.$utils = utils;

Vue.config.productionTip = false;

import request from './util/request';
Vue.prototype.$request = request;
import { deleteFile, downloadFiles, checkPermission, throttle, checkRolePermission } from '@/project/utils/index.js';
Vue.prototype.$downloadFiles = downloadFiles;
Vue.prototype.$deleteFile = deleteFile;
Vue.prototype.$checkPermission = checkPermission;
Vue.prototype.$throttle = throttle;
Vue.prototype.$checkRolePermission = checkRolePermission;

// 引入并注册组件
import globalComponent from '@/project/components/register.js';
Vue.use(globalComponent);

Vue.directive('filterSpecialChar', {
  update: function (el, { value, modifiers }, vnode) {
    try {
      let a_el = el.children[0];

      if (!a_el.value) {
        return false;
      }
      a_el.value = a_el.value.replace(/[^a-zA-Z0-9\u4E00-\u9FA5#@%]/g, '');
      a_el.dispatchEvent(new Event(modifiers.lazy ? 'change' : 'input'));
    } catch (e) {}
  },
});

Vue.filter('numFixed', (val, n1, n2) => {
  if (!val) return 0;
  if (n2) val = val / n2;
  const arr = val.toFixed(n1).split('.');
  arr[0] = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return arr.join('.');
});

const vue = new Vue({
  render: (h) => h(App),
  store,
  router,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount('#app');

window._paq.push(['trackPageView']);  // 跟踪页面视图

export default vue;
